<template>
  <footer class="app-footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-social">
          <a href="https://www.instagram.com/nh_liga/" target="_blank" rel="noopener noreferrer" class="social-link" aria-label="Instagram">
            <i class="bi bi-instagram"></i>
          </a>
          <a href="https://www.facebook.com/profile.php?id=61579409891772" target="_blank" rel="noopener noreferrer" class="social-link" aria-label="Facebook">
            <i class="bi bi-facebook"></i>
          </a>
        </div>
        <div class="footer-text">
          <p>© {{ new Date().getFullYear() }} Noční hokejová liga</p>
          <p>Vytvořil: <a href="mailto:ivosajer@live.com">Ivo Šajer</a></p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
.app-footer {
  background: linear-gradient(180deg, #0d1429, #080e1e);
  border-top: 1px solid rgba(31, 224, 255, 0.1);
  padding: 2rem 0;
  margin-top: 2rem;
}

.footer-content {
  text-align: center;
  color: #8892b0;
}

.footer-text {
  font-size: 0.9rem;
}

.footer-text p {
  margin-bottom: 0.25rem;
}

.footer-text a {
  color: #8892b0;
  text-decoration: none;
  transition: color 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.footer-text a:hover {
  color: #1fe0ff;
}

.footer-social {
  display: flex;
  justify-content: center;
  gap: 1.25rem;
  margin-bottom: 1rem;
}

.social-link {
  color: #8892b0;
  font-size: 1.4rem;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid rgba(31, 224, 255, 0.1);
}

.social-link:hover {
  color: #1fe0ff;
  border-color: rgba(31, 224, 255, 0.3);
  box-shadow: 0 0 12px rgba(31, 224, 255, 0.15);
  transform: translateY(-2px);
}
</style> 